import headerCustomTheme, { ThemeType } from '../theme/headerCustomTheme';

// Use club font face names defined in scss
// @see alice/alice/public/themes/core/css/fonts.scss
const fontFamilyBrandonMedium = 'Brandon Text Medium';
const fontFamilyBrandonRegular = 'Brandon Text Regular';
const fontFamilyChronicleRoman = 'ChronicleDisplay-Roman';

export const clubTheme: ThemeType = {
    ...headerCustomTheme,
    colors: {
        ...headerCustomTheme.colors,
    },
    fonts: {
        ...headerCustomTheme.fonts,
        fontBrandonMedium: `'${fontFamilyBrandonMedium}', ${headerCustomTheme.fonts.fontBrandonMedium}`,
        fontBrandonRegular: `'${fontFamilyBrandonRegular}', ${headerCustomTheme.fonts.fontBrandonRegular}`,
        fontChronicleRoman: `'${fontFamilyChronicleRoman}', ${headerCustomTheme.fonts.fontChronicleRoman}`,
    },
};
